import Vue from 'vue';
import Project from 'src/api/project';
import { mapGetters } from 'vuex';
import { sortBy } from 'lodash';
export default Vue.extend({
    metaInfo() {
        return {
            title: this.currentSite ? `${this.currentSite.site_name} - Kapiche` : 'Kapiche'
        };
    },
    async beforeRouteEnter(to, from, next) {
        try {
            const response = await Project.getAllDashboards();
            next(vm => {
                vm.dashboards = response;
                vm.$analytics.track.site.viewerHome(vm.currentUser.id, vm.dashboards.length);
            });
        }
        catch (error) {
            next();
        }
    },
    /**
     * This is used when changing between sites in the sidebar. beforeRouteEnter
     * doesn't work if only the "params" portion of the $router.push args
     * changes.
     */
    async beforeRouteUpdate(to, from, next) {
        try {
            this.data = await Project.getAllDashboards();
        }
        finally {
            next();
        }
    },
    data() {
        return {
            dashboards: []
        };
    },
    computed: {
        ...mapGetters(['currentUser', 'currentSite', 'featureFlags']),
        dashboardTree() {
            return sortBy(this.dashboards, ['project_name', 'analysis_name', 'name'])
                .reduce((tree, dashboard) => {
                if (!tree[dashboard.project_name]) {
                    tree[dashboard.project_name] = {};
                }
                if (!tree[dashboard.project_name][dashboard.analysis_name]) {
                    tree[dashboard.project_name][dashboard.analysis_name] = [];
                }
                tree[dashboard.project_name][dashboard.analysis_name].push({ name: dashboard.name, id: dashboard.id, url_code: dashboard.url_code });
                return tree;
            }, {});
        },
    },
});
